import { Phone, MessageCircle } from "lucide-react";
import { COMPANY } from "@/data/site";

export default function MobileBar() {
  return (
    <div data-testid="mobile-action-bar" className="fixed bottom-0 inset-x-0 z-50 sm:hidden bg-white border-t border-slate-200 shadow-[0_-4px_12px_rgba(0,0,0,0.08)] flex">
      <a
        data-testid="mobile-call-btn"
        href={`tel:${COMPANY.phone1Raw}`}
        className="flex-1 flex items-center justify-center gap-2 py-4 bg-[#1e3a8a] text-white text-xs font-bold uppercase tracking-wider"
      >
        <Phone className="w-4 h-4" aria-hidden="true" /> Call Now
      </a>
      <a
        data-testid="mobile-whatsapp-btn"
        href={COMPANY.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        className="flex-1 flex items-center justify-center gap-2 py-4 bg-emerald-600 text-white text-xs font-bold uppercase tracking-wider"
      >
        <MessageCircle className="w-4 h-4" aria-hidden="true" /> WhatsApp
      </a>
    </div>
  );
}
